import React from "react";
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider, indexedDBLocalPersistence, initializeAuth, User } from "firebase/auth";
import { getDatabase, ref, get, update, push, onValue } from "firebase/database";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import { connect } from "react-redux";
import { getStorage } from "@firebase/storage";
import { authActions, createUser } from "./modules/authentication/store/actions";
import { appVersion } from "./appVersion";
import {
	browserName,
	deviceType,
	fullBrowserVersion,
	isAndroid,
	isIOS,
	isMobile,
	isSafari,
	mobileModel,
	mobileVendor,
	osName,
	osVersion,
} from "react-device-detect";
import i18n from "./i18n";
import { IonLoading, isPlatform } from "@ionic/react";
import { getFirestore } from "firebase/firestore";
import { paywallActions } from "./common/Paywall/store/actions";
import { setTheme } from "./theme/theme";
import { Product } from "./common/Paywall/store/paywallUtils";
import { userServices } from "./modules/user/store/services";
import { userActions } from "./modules/user/store/actions";
import { store } from "./common/store";
import { getRemoteConfig, fetchAndActivate, getValue } from "firebase/remote-config";
import * as amplitude from "@amplitude/analytics-browser";
import { Organization, Organization_New, UserLicense } from "./modules/user/store/reducers";
import { settingsServices } from "./modules/settings/store/services";
import { SocialLogin } from "@capgo/capacitor-social-login";
import storeHandler from "./common/purchasehandler";

export const firebaseConfig = {
  apiKey: "AIzaSyCBPvpL-1OjclAZ1LyPdIRWcvuQQgFgAUA",
  authDomain: "t4a-reasy.firebaseapp.com",
  databaseURL: "https://t4a-reasy-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "t4a-reasy",
  storageBucket: "t4a-reasy.appspot.com",
  messagingSenderId: "888298030729",
  appId: "1:888298030729:web:236df6514e94b7b4fa2858",
  measurementId: "G-BNW8HVPDFJ"
};

export const app = initializeApp(firebaseConfig);

export const remoteConfig = getRemoteConfig();
remoteConfig.settings = {
	minimumFetchIntervalMillis: 3600000, // Cache expiration time, e.g., 1 hour
	fetchTimeoutMillis: 60000, // Fetch timeout, e.g., 1 minute
};
getAnalytics(app);

export const auth = isIOS
	? initializeAuth(app, {
			persistence: indexedDBLocalPersistence,
	  })
	: getAuth();

// export const auth = getAuth();
console.log("FIRST AUTH ", auth);
auth.useDeviceLanguage();
export const database = getDatabase();
export const firestore = getFirestore();
export const functions = getFunctions(undefined, "europe-west1");
export const storage = getStorage();

try {

	// if (isAndroid) {
	// 	SocialLogin.initialize({
	// 		google: {
	// 			webClientId: "888298030729-4drthn6uc61e2b7p2coqskl19j8d58r7.apps.googleusercontent.com",
	// 		},
	// 	});
	// }
	SocialLogin.initialize({
		google: {
			webClientId: "888298030729-4drthn6uc61e2b7p2coqskl19j8d58r7.apps.googleusercontent.com",
			iOSClientId: "888298030729-hoeev4m5inracd507utkvp3o5q42ccmg.apps.googleusercontent.com",
		},
		apple:{
			clientId: "888298030729-4drthn6uc61e2b7p2coqskl19j8d58r7.apps.googleusercontent.com",
			redirectUrl: 'https://appleloginvps.wcaleniewolny.me/login/callback',
		}
	});
	console.log("INITIALIZED");
} catch (error) {}

export const microsoftAuthProvider = new OAuthProvider("microsoft.com");
microsoftAuthProvider.setCustomParameters({ prompt: "select_account" });

export const appleAuthProvider = new OAuthProvider("apple.com");
appleAuthProvider.addScope("email");
type Props = {
	authenticationSuccess: (userData: User) => void;
	setOrganizations: (org_data: Organization_New[] | null | "Private") => void;

	logout: () => void;

	showPaywall: () => void;
	hidePaywall: () => void;
};

type State = {
	orgActiveProducts: Product[];
	userProducts: Product[];
	isLoading: boolean;
};

class Authentication extends React.Component<Props, State> {
	constructor(props: any) {
		super(props);
		this.state = {
			orgActiveProducts: [],
			userProducts: [],
			isLoading: false,
		};
	}

	componentDidMount() {
		auth.onAuthStateChanged(async (userData) => {
			if (userData === null) {
				return;
			}

			console.log(userData);
			storeHandler()
			try {
				// Small delay to let backend initialize
				//   await new Promise(resolve => setTimeout(resolve, 2000));

				const bearerToken = await userData.getIdToken();
				//   const result = await createUser(bearerToken, userData.uid,userData.displayName?.trim(),userData.metadata.creationTime,userData.email);
				//   console.log(result);

				//   if (!result) {
				//     console.error('Failed to create user');
				//     return;
				//   }

				// Initialize amplitude early
				amplitude.init("c212f94f9c1f65a8fca4e904bd5c00c7", {
					userId: userData.uid,
					defaultTracking: true,
				});

				// Execute async operations sequentially with individual error handling
				// await this.loadUserOrganizations(userData.uid, bearerToken);
				await this.loadUserSettings(userData.uid, bearerToken);
				await this.loadUserLanguage(userData.uid, bearerToken);

				// Call authentication success at the end
				this.props.authenticationSuccess(userData);
			} catch (error) {
				console.error("[AUTH ERROR]", error);

				// get user data
				// loadPaywall()

				// get(ref(database, `u/${userData.uid}`))
				// 	.then((data) => {
				// 		if (!data.val() || !data.val()["e"]) {
				// 			update(ref(database, `u/${userData.uid}`), {
				// 				e: userData.email,
				// 			});
				// 		}

				// 		if (!data.val() || !data.val()["l"]) {
				// 			update(ref(database, `u/${userData.uid}`), {
				// 				l: i18n.language,
				// 			});
				// 		}

				// 		// if (data.val() && data.val()["l"]) {
				// 		// 	localStorage.setItem('languageview', data.val()["l"])
				// 		// 	i18n.changeLanguage(data.val()["l"]);
				// 		// }

				// 		// if (data.val() && data.val()["t"]) {
				// 		// 	setTheme(data.val()["t"]);
				// 		// }
				// 	})
				// 	.catch((err) => {
				// 		//console.log("[firebase.tsx] error getting user data:", err);
				// 	});

				// const nowTimestamp = Math.round(new Date().getTime() / 1000);
				// let deviceInfo = {
				// 	t: deviceType,
				// 	o: osName + " - " + osVersion,
				// 	b: browserName + " - " + fullBrowserVersion,
				// 	m: isMobile ? mobileVendor + " - " + mobileModel : null,
				// };
				// push(ref(database, `l/u/${userData.uid}/a`), {
				// 	t: nowTimestamp,
				// 	v: appVersion,
				// 	d: deviceInfo,
				// })
				// 	.then(() => {
				// 		//console.log("[firebase] a. push success");
				// 	})
				// 	.catch((err) => {
				// 		//console.log("[firebase] error logging:", err);
				// 	});

				// const updateProductsState = httpsCallable(functions, "updateProductsState-updateProductsState");
				// updateProductsState()
				// 	.then((res) => {
				// 		// console.log("[Firebase] update product state res:", res.data); // TO REMOVE
				// 		if ((res.data as any).error) {
				// 			console.error("[Firebase] error returned by the updateProductsState cloud function:", res.data);
				// 		}
				// 	})
				// 	.catch((err) => {
				// 		console.error("[Firebase] error calling updateProductsState cloud function:", err);
				// 	});
				// this.setState({isLoading:true})
				// GET USER PRODUCTS
				// } else {
				// 	console.log("[Firebase] We did not authenticate.");
				// 	this.props.logout();
				// 	this.props.setOrganizations(null);
			}
		});
	}

	render() {
		return (
			<>
				<IonLoading isOpen={this.state.isLoading}></IonLoading>
			</>
		);
	}
	// Separate method for loading organizations
	private async loadUserOrganizations(userId: string, bearerToken: string) {
		try {
			const orgData = await userServices.getUserOrganizations(userId, bearerToken);
			console.log("found org data: ", orgData);
			this.props.setOrganizations(orgData || null);
		} catch (error) {
			console.error("[ORG DATA ERROR]", error);
			// Set organizations to null on error
			this.props.setOrganizations(null);
		}
	}

	// Separate method for loading user settings
	private async loadUserSettings(userId: string, bearerToken: string) {
		try {
			const userSettings = await settingsServices.getUserSettings(userId, bearerToken);
			setTheme(userSettings?.theme || "default");
		} catch (error) {
			console.error("[USER SETTINGS ERROR]", error);
			// Fall back to default theme
			setTheme("default");
		}
	}

	// Separate method for loading user language
	private async loadUserLanguage(userId: string, bearerToken: string) {
		try {
			const userLanguage = navigator.language || navigator.languages?.[0] || "en";
			let response = await settingsServices.getPrimaryLanguage(userId, bearerToken);

			if (response === null) {
				await settingsServices.setPrimaryLanguage(userId, bearerToken, userLanguage);
				response = userLanguage;
			}

			await i18n.changeLanguage(response);
		} catch (error) {
			console.error("[LANGUAGE ERROR]", error);
			// Fall back to browser language or English
			const fallbackLanguage = navigator.language || navigator.languages?.[0] || "en";
			await i18n.changeLanguage(fallbackLanguage);
		}
	}
}

const mapDispatchToProps = (dispatch: any) => {
	return {
		authenticationSuccess: (userData: User) => {
			dispatch(authActions.authenticationSuccess(userData));
		},
		setOrganizations: (org_data: Organization_New[] | null) => {
			dispatch(userActions.setOrganizations(org_data));
		},
		logout: () => {
			dispatch(authActions.logout());
		},

		showPaywall: () => {
			dispatch(paywallActions.showPaywall());
		},

		hidePaywall: () => {
			dispatch(paywallActions.hidePaywall());
		},
	};
};

export default connect(null, mapDispatchToProps)(Authentication);
